<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <data-table (detail)="onDetail($event)" (edit)="onEdit($event)" [columns]="columns" [dataProvider]="customerService"
                  [title]="title"></data-table>
</page-content>
